import React, { useMemo } from "react";
import * as Mui from "@mui/material";
import { designShell } from "services/constants/designTokens";

// "All Records / From Attendance / Imported / Manual Entries" tabs shown
// above a Pay Inputs list's summary cards. The cards and the table then use
// only the selected tab's rows. Each tab shows how many rows it holds.

export const SOURCE_TABS = {
  all: { key: "all", label: "All Records" },
  attendance: { key: "attendance", label: "From Attendance" },
  imported: { key: "imported", label: "Imported" },
  manual: { key: "manual", label: "Manual Entries" },
};

// Row source -> tab key. Matched loosely because the API's source labels
// are not confirmed ("Attendance" / "System", "Import" / "Imported" / "ERP",
// "Manual"). Anything else only shows under All Records.
export const sourceTabKey = (source) => {
  const text = String(source ?? "").toLowerCase();
  if (text.includes("attend") || text.includes("system")) return "attendance";
  if (text.includes("import") || text.includes("erp") || text.includes("migrat")) return "imported";
  if (text.includes("manual")) return "manual";
  return "other";
};

export const filterBySourceTab = (rows, tab) =>
  tab === "all" ? rows : rows.filter((row) => sourceTabKey(row.source) === tab);

// tabs: keys of SOURCE_TABS in display order. rows: the rows before the tab
// filter (for the counts). disabledTabs: keys shown but not selectable (a
// screen whose API has no source for its rows yet).
export const SourceTabs = ({ tabs, value, onChange, rows, disabledTabs = [] }) => {
  const counts = useMemo(() => {
    const result = { all: rows.length };
    rows.forEach((row) => {
      const key = sourceTabKey(row.source);
      result[key] = (result[key] ?? 0) + 1;
    });
    return result;
  }, [rows]);

  return (
    <Mui.Box sx={{ ...designShell.sectionCard, px: 2, mb: 1.5 }}>
      <Mui.Tabs
        value={value}
        onChange={(event, next) => onChange(next)}
        variant="scrollable"
        allowScrollButtonsMobile
        sx={designShell.panelTabs}
      >
        {tabs.map((key) => (
          <Mui.Tab
            key={key}
            value={key}
            disabled={disabledTabs.includes(key)}
            label={`${SOURCE_TABS[key].label} (${(counts[key] ?? 0).toLocaleString("en-IN")})`}
          />
        ))}
      </Mui.Tabs>
    </Mui.Box>
  );
};
